import router from "./router";
import store from "./store";
import NProgress from 'nprogress'; // progress bar
import 'nprogress/nprogress.css'; // progress bar style
import getPageTitle from '@/utils/getPageTitle';
import { Notification } from '@hs/hanshow-ui';
import i18n from "@/i18n/index";
import { getJid } from '@/utils/auth';
import { hiddenWithinGlobal } from '@/router/hiddenRoute';
NProgress.configure({ showSpinner: false });
const packageName = 'prismart';

// const parentRouteName = window.__POWERED_BY_QIANKUN__ ? `/${packageName}` : '/';
const whiteList = ['login']; // no redirect whitelist
const noRoleWhiteList = ['modifyPassword', 'mfa'];
let retryTime = 0;
let count = 0;
router.beforeEach(async (to, from, next) => {
    NProgress.start();
    document.title = getPageTitle(to.meta.title);

    const hasToken = getJid();
    if (hasToken) {
        if (to.name == 'login') {
            next({ name: 'dashboardPage' });
            NProgress.done();
        } else {
            const parentRouteName = window.__POWERED_BY_QIANKUN__ ? (store.state.global.props.baseUrl ? `/${store.state.global.props.baseUrl}` : `/${packageName}`) : '/';

            const hasRoles = store.getters.roles && store.getters.roles.length > 0;
            if (hasRoles || noRoleWhiteList.includes(to.name)) {
                if (!from.name && to.name === 'mfa' && count < 1) {
                    count++;
                    next({ name: 'dashboardPage' });
                }
                if (window.__POWERED_BY_QIANKUN__ && !store.state.global.props.getGlobalState('servicePage') && hiddenWithinGlobal.includes(to.name)) {
                    next({ name: 'dashboardPage' });
                    NProgress.done();
                    return;
                }
                next();
                NProgress.done();
            } else {
                try {
                    if (retryTime > 2) return;
                    const { roles, user, customerObj, response = {} } = await store.dispatch('user/getInfo');
                    if (!response.resultCode) {
                        const accessRoutes = await store.dispatch('permission/generateRoutes', { roles, user });

                        accessRoutes.forEach(route => {
                            router.addRoute(parentRouteName, route);
                        });

                        const userInfo = user;
                        const customers = customerObj;
                        await store.dispatch('app/getSystemTranslate');

                        if (window.__POWERED_BY_QIANKUN__) {
                            await store.dispatch('app/quankunloadshow', { userInfo, customers });
                            if (!store.state.global.props.getGlobalState('servicePage') && hiddenWithinGlobal.includes(to.name)) {
                                next({ name: 'dashboardPage' });
                            } else {
                                next({ ...to, replace: true });
                            }
                        } else {
                            await store.dispatch('app/loadShow', { userInfo, customers });
                            next({ ...to, replace: true });
                        }
                    } else {
                        next();
                        // next({ ...to, replace: true });
                        NProgress.done();
                    }


                } catch (error) {
                    retryTime++;
                    if (error) {
                        Notification.closeAll();
                        Notification.error(i18n.t(`promptMessage.noContent`));
                        if (!window.__POWERED_BY_QIANKUN__) {
                            await new Promise(resolve => setTimeout(resolve, 1500));
                            await store.dispatch('user/logout');
                        }

                    } else {
                        Notification.error('Has Error');
                    }
                    next({ name: 'login' });
                    // next(`/login?redirect=${to.name}`);
                    NProgress.done();
                }
            }
        }


    } else {
        /* has no token*/
        if (whiteList.includes(to.name)) {
            next();
        } else {
            // if (window.HS_CONST.SPECIAL_SIGNIN || window.HS_CONST.SIGN_TYPE) {
            //     let nextName = to.name ? `/casLogin?redirect=${to.name}` : '/casLogin';
            //     next(nextName);
            // } else {
            //     let nextName = to.name ? `/login?redirect=${to.name}` : '/login';
            //     next(nextName);
            // }
            next({ name: 'login' });
            NProgress.done();
        }
    }
});

router.afterEach(() => {
    // finish progress bar
    NProgress.done();
});